(function () {
  var KEY = 'dheesh_wishlist';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    renderPage();
  }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
  }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-wishlist-label]');
      var text = on ? 'Saved to wishlist' : 'Add to wishlist';
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(list.length)) el.textContent = list.length;
      if (el.hidden !== (list.length === 0)) el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.handle);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 2 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    empty.hidden = list.length > 0;
    Promise.all(list.map(fetchProduct)).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        var avail = p.variants.filter(function (x) { return x.available; });
        var action = !avail.length ? '<span class="price">Out of stock</span>'
          : p.variants.length === 1 ? '<button type="button" class="button button--primary" data-wishlist-add="' + avail[0].id + '">Add to cart</button>'
          : '<a class="button button--secondary" href="' + esc(p.url) + '">Select options</a>';
        html += '<div class="dheesh-wishlist-item">' +
          '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="dheesh-wishlist-btn is-active" data-wishlist-toggle data-handle="' + esc(list[i]) + '" aria-pressed="true" aria-label="Remove from wishlist"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-8-4.9-8-11A4.6 4.6 0 0 1 12 6.6a4.6 4.6 0 0 1 8 2.9c0 6.1-8 11-8 11Z"/></svg></button>' +
          '<a class="title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="price">' + money(p.price) + '</span>' + action + '</div>';
      });
      grid.innerHTML = html;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-add]');
    if (!b) return;
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(b.dataset.wishlistAdd), quantity: 1 }) })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { b.disabled = false; });
  });

  function init() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; sync(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
